import { render, staticRenderFns } from "./HoistingCollapseContent.vue?vue&type=template&id=f60087d8&scoped=true&"
import script from "./HoistingCollapseContent.vue?vue&type=script&lang=js&"
export * from "./HoistingCollapseContent.vue?vue&type=script&lang=js&"
import style0 from "./HoistingCollapseContent.vue?vue&type=style&index=0&id=f60087d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60087d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60087d8')) {
      api.createRecord('f60087d8', component.options)
    } else {
      api.reload('f60087d8', component.options)
    }
    module.hot.accept("./HoistingCollapseContent.vue?vue&type=template&id=f60087d8&scoped=true&", function () {
      api.rerender('f60087d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/HoistingCollapseContent.vue"
export default component.exports